import { Switch, Route, Redirect } from "react-router"
import { Tabs, Tab, Content } from "./VerticalTabs.style"

const VerticalTabs = ({ path, tabs }) => (
  <>
    <Tabs>
      {tabs.map(({ name }) => (
        <Tab to={`${path}/${name.toLowerCase()}`} width={100 / tabs.length}>
          {name}
        </Tab>
      ))}
    </Tabs>
    <Content>
      <Switch>
        {tabs.map(({ name, component: Component }) => (
          <Route key={name} path={`${path}/${name}`} component={Component} />
        ))}
        <Route render={() => <Redirect to={`${path}/${tabs[0]?.name?.toLowerCase()}`} />} />
      </Switch>
    </Content>
  </>
)

export default VerticalTabs
